/**
 * @module lib/commercial/keytar/globe-advisor
 */
import template from "./template";
import Wall from "lib/commercial/keytar/Wall";
import { WALL_TYPES } from "lib/commercial/keytar/WallAnalyticsSchema";
import { ENTITLEMENTS } from "lib/identity/entitlements";
import { isFreeToViewReferrer } from "lib/commercial/keytar/helpers";
import isNil from "lodash/isNil";
import logger from "utils/logger";
import { processObjectMethods } from "../helpers";

const name = "globeAdvisorWall";
const debugTag = `[KEYTAR] ${name}`;

const rules = [{
  /** @returns {Boolean} true when access is allowed for user */
  accessAllowed({ customer }) {
    if (isNil(customer)) {
      return false;
    }
    const allowed = {
      isFreeToView: () => isFreeToViewReferrer(),
      isGA: () => customer.hasService(ENTITLEMENTS.ADVISOR.value)
    };
    const access = processObjectMethods(allowed);
    logger.info(`${debugTag} access:`, access, allowed);
    return access;
  },
  /** @returns {Boolean} true when wall should be used for article or section page */
  matcher({ url }) {
    // note the lack of a /g flag here: implementing it may cause /re/.test(str) to do weird things
    // see http://2ality.com/2013/08/regexp-g.html for more info

    // Show wall for CE Centre landing page (with/without query string and hash in URL) and no subpages as well as Globe Advisor article/gallery/video pages.
    const blackList = /.*?\/globe-advisor\/(cecentre\/(\?[\w\-\=\#\&\%]+)*$|(([\w\-]+\/)*(article|gallery|video)+([\w\-]+)\/*))/im;

    const whiteList = /.*?\/globe-advisor\/advisor-news\/([\w\-]+\/)*(article|gallery|video)+([\w\-]+)\/*/im;
    return whiteList.test(url) ? false : blackList.test(url);
  },
  /** @type {String} */
  name: name
}];

const props = {
  rules,
  featureFlagName: `${name}Enabled`, // defined in environment-variables.jsp
  template
};

export default new Wall("globe-advisor-content-page", WALL_TYPES.PAYWALL_HARD, props);
